import React, { Component } from 'react';

class IconPlusCircleBlue extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="25"
                fill="none"
                viewBox="0 0 27 25"
            >
                <path
                    fill="#1EA9FC"
                    d="M13.788 0c-2.58 0-5.102.723-7.247 2.078C4.396 3.433 2.724 5.36 1.737 7.614a11.716 11.716 0 00-.744 7.127c.503 2.393 1.745 4.591 3.57 6.317 1.823 1.725 4.147 2.9 6.677 3.377 2.53.476 5.152.232 7.536-.701 2.383-.934 4.42-2.515 5.854-4.544a11.866 11.866 0 002.198-6.853c.001-1.62-.336-3.224-.991-4.721a12.31 12.31 0 00-2.827-4.003A13.113 13.113 0 0018.78.94 13.69 13.69 0 0013.787 0zm7.573 13.728c0 .16-.067.312-.186.424a.654.654 0 01-.448.176H15.89v4.576c0 .16-.067.312-.186.424a.653.653 0 01-.449.176h-2.942a.653.653 0 01-.449-.176.584.584 0 01-.185-.424v-4.579H6.844a.653.653 0 01-.449-.176.584.584 0 01-.186-.424v-2.783c0-.16.067-.312.186-.424a.653.653 0 01.449-.176h4.838V5.769c0-.16.067-.312.186-.424a.653.653 0 01.448-.176h2.945c.168 0 .33.063.448.176a.584.584 0 01.186.424v4.576h4.838c.168 0 .33.063.449.176a.584.584 0 01.186.424l-.007 2.783z"
                ></path>
            </svg>
        );
    }
}

export default IconPlusCircleBlue;